if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getSectionsToRequest() {
        const sectionIds = ['cart-icon-bubble'];

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          this.cart.getSectionsToRender().forEach((section) => {
            if (section.id && !sectionIds.includes(section.id)) {
              sectionIds.push(section.id);
            }
          });
        }

        return sectionIds;
      }

      updateHeaderCartIcon(response) {
        if (response?.sections && typeof window.paintCartIconFromSections === 'function') {
          if (window.paintCartIconFromSections(response.sections)) return;
        }

        if (typeof window.refreshCartIconBubble === 'function') {
          window.refreshCartIconBubble();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', this.getSectionsToRequest().join(','));
        formData.append('sections_url', window.location.pathname);

        if (this.cart && typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            const startMarker =
              typeof CartPerformance !== 'undefined'
                ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
                : null;

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              if (startMarker && typeof CartPerformance !== 'undefined') {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              }
            });

            const quickAddModal = this.closest('quick-add-modal');
            const paintSections = () => {
              if (typeof window.refreshCartUI === 'function') {
                window.refreshCartUI(response.sections);
              } else {
                this.updateHeaderCartIcon(response);
              }

              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              } else if (typeof window.refreshCartDrawer === 'function') {
                window.refreshCartDrawer();
              }
            };

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (typeof CartPerformance !== 'undefined') {
                      CartPerformance.measure('add:paint-updated-sections', paintSections);
                    } else {
                      paintSections();
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (typeof CartPerformance !== 'undefined') {
              CartPerformance.measure('add:paint-updated-sections', paintSections);
            } else {
              paintSections();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            if (typeof CartPerformance !== 'undefined') {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
